import React, {useEffect} from 'react'
import './Brainshare.css'
import Bsintroimage from '../images/Brainshareimages/Bsintroimage.png'
import Artboard1 from '../images/Brainshareimages/Artboard1.png'

import Artboard3 from '../images/Brainshareimages/Artboard3.png'
import Artboard4 from '../images/Brainshareimages/Artboard4.png'
import Artboard5 from '../images/Brainshareimages/Artboard5.png'
import Artboard6 from '../images/Brainshareimages/Artboard6.png'
import Artboard7 from '../images/Brainshareimages/Artboard7.png'
import Artboard8 from '../images/Brainshareimages/Artboard8.png'
import Artboard9 from '../images/Brainshareimages/Artboard9.png'
import Artboard10 from '../images/Brainshareimages/Artboard10.png'
import Artboard11 from '../images/Brainshareimages/Artboard11.png'
import Artboard12 from '../images/Brainshareimages/Artboard12.png'
import Artboard13 from '../images/Brainshareimages/Artboard13.png'
import Artboard14 from '../images/Brainshareimages/Artboard14.png'
import Artboard15 from '../images/Brainshareimages/Artboard15.png'
import Artboard16 from '../images/Brainshareimages/Artboard16.png'
import Artboard17 from '../images/Brainshareimages/Artboard17.png'
import Artboard18 from '../images/Brainshareimages/Artboard18.png'
import Artboard19 from '../images/Brainshareimages/Artboard19.png'
import Artboard20 from '../images/Brainshareimages/Artboard20.png'
import Artboard21 from '../images/Brainshareimages/Artboard21.png'
import Artboard22 from '../images/Brainshareimages/Artboard22.png'
import Artboard23 from '../images/Brainshareimages/Artboard23.png'
import Artboard24 from '../images/Brainshareimages/Artboard24.png'
import Artboard25 from '../images/Brainshareimages/Artboard25.png'
import Artboard26 from '../images/Brainshareimages/Artboard26.png'
import Artboard27 from '../images/Brainshareimages/Artboard27.png'
import Artboard28 from '../images/Brainshareimages/Artboard28.png'
import Artboard29 from '../images/Brainshareimages/Artboard29.png'
import Artboard30 from '../images/Brainshareimages/Artboard30.png'
import Footer from '../Component/footer'

function Brainshare() {
    useEffect(() => {
        window.scroll(0, 0);
        document.body.scrollTop = 0;
    }, []);
    return (
        <div>
       
        <div className="imagevh" id="imageAndroidscreenshoot"><img src={Bsintroimage} height="" width="100%" alt=""/></div>
        
        <div className="project-details-BS">
        <div className="client-role-BS">
            <h4 className="client-project-BS">CLIENT</h4>
            <h2 className="portfolio-heading-BS1"> Brainshare Tecnologies(NINEXT)</h2>
            <h4 className="role-BS">
            ROLE
            </h4>
            <h2 className="portfolio-role-BS2">Social Media Content Creator</h2>
           </div>
            <h4 className="client-details-BS"> DETAILS
            </h4>
            <p className="client-details-BS-p">
            Brainshare Technologies is the fastest growing fiber internet and other digital 
            consumer-centric services provider in the country today. With over 2,000 km 
            of Pure 100% Fiber Optic Network 
            capacity our premium products and services are best positioned to serve you.
            </p>

            <p className="client-details-BS-p2">
           NINEXT is a subsidiary of Brainshare Technologies
        
            </p>
         </div>


         <div className="imagevh" id="artboard"><img src={Artboard1} height="auto" width="100%" alt=""/></div>
      
         <div className="imagevh" id="artboard"><img src={Artboard3} height="auto" width="100%" alt=""/></div>
         <div className="imagevh" id="artboard"><img src={Artboard4} height="auto" width="100%" alt=""/></div>
         <div className="imagevh" id="artboard"><img src={Artboard5} height="auto" width="100%" alt=""/></div>
         <div className="imagevh" id="artboard"><img src={Artboard6} height="auto" width="100%" alt=""/></div>
         <div className="imagevh" id="artboard"><img src={Artboard7} height="auto" width="100%" alt=""/></div>
         <div className="imagevh" id="artboard"><img src={Artboard8} height="auto" width="100%" alt=""/></div>
         <div className="imagevh" id="artboard"><img src={Artboard9} height="auto" width="100%" alt=""/></div>
         <div className="imagevh" id="artboard"><img src={Artboard10} height="auto" width="100%" alt=""/></div>
         <div className="imagevh" id="artboard"><img src={Artboard11} height="auto" width="100%" alt=""/></div>
         <div className="imagevh" id="artboard"><img src={Artboard12} height="auto" width="100%" alt=""/></div>
         <div className="imagevh" id="artboard"><img src={Artboard13} height="auto" width="100%" alt=""/></div>
        
         <div className="imagevh" id="artboard"><img src={Artboard15} height="auto" width="100%" alt=""/></div>
          <div className="imagevh" id="artboard"><img src={Artboard14} height="auto" width="100%" alt=""/></div>
          <div className="imagevh" id="artboard"><img src={Artboard16} height="auto" width="100%" alt=""/></div>
          <div className="imagevh" id="artboard"><img src={Artboard17} height="auto" width="100%" alt=""/></div>
          <div className="imagevh" id="artboard"><img src={Artboard18} height="auto" width="100%" alt=""/></div>
          <div className="imagevh" id="artboard"><img src={Artboard19} height="auto" width="100%" alt=""/></div>
          <div className="imagevh" id="artboard"><img src={Artboard20} height="auto" width="100%" alt=""/></div>
          <div className="imagevh" id="artboard"><img src={Artboard21} height="auto" width="100%" alt=""/></div>
          <div className="imagevh" id="artboard"><img src={Artboard22} height="auto" width="100%" alt=""/></div>
          <div className="imagevh" id="artboard"><img src={Artboard23} height="auto" width="100%" alt=""/></div>
          <div className="imagevh" id="artboard"><img src={Artboard24} height="auto" width="100%" alt=""/></div>
          <div className="imagevh" id="artboard"><img src={Artboard25} height="auto" width="100%" alt=""/></div>
          <div className="imagevh" id="artboard"><img src={Artboard26} height="auto" width="100%" alt=""/></div>
          <div className="imagevh" id="artboard"><img src={Artboard27} height="auto" width="100%" alt=""/></div>
          <div className="imagevh" id="artboard"><img src={Artboard28} height="auto" width="100%" alt=""/></div>
          <div className="imagevh" id="artboard"><img src={Artboard29} height="auto" width="100%" alt=""/></div>
          <div className="imagevh" id="artboard"><img src={Artboard30} height="auto" width="100%" alt=""/></div>
          <div className="imagevh" id="artboard" ><Footer /></div> 


         
        </div>
    )
}

export default Brainshare